<template>
  <div class="relative rounded-md min-h-48 overflow-hidden">
    <strapi-image
      v-if="component.customComponent.backgroundImage"
      class="absolute inset-0 w-full h-full rounded-md object-cover shadow-md"
      :image="component.customComponent.backgroundImage"
      :image-class="'w-full h-full object-cover rounded'"
      :lazy="false"
    />
    <div
      class="relative p-4 md:p-8 lg:p-12 flex flex-wrap items-center justify-between"
    >
      <div class="w-full md:flex-1 lg:w-1/2">
        <h2 class="mb-0 uppercase">{{ component.customComponent.title }}</h2>
        <div class="mt-4 tracking-[1.5px]" v-html="renderedContent"></div>
        <a
          v-for="btn in component.customComponent.buttons"
          :key="btn.id"
          class="inline-block mt-4 px-8 py-1.5 rounded-md font-bold uppercase tracking-wider hover:opacity-90 transition-opacity no-underline"
          :class="strapiBtnClass(btn.type)"
          :href="btn.link"
          :target="btn.newTab ? '_blank' : '_self'"
        >
          {{ btn.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiCustomComponent } from '~/apollo/types/types';

const props = defineProps<{
  component: StrapiCustomComponent;
}>();

const md = useMarkdownIt();
const renderedContent = computed(() => {
  const content = props.component.customComponent?.content;
  return content ? md.render(content) : '';
});

const btnTypeClasses: Record<string, string> = {
  primary: 'bg-brand text-onyx',
  secondary: 'bg-mouse text-depth-0',
  'outline-primary':
    'border border-brand text-brand hover:bg-brand hover:text-onyx',
};

function strapiBtnClass(type: string): string {
  return btnTypeClasses[type] ?? btnTypeClasses.primary;
}
</script>
